import { render, staticRenderFns } from "./yqdj.vue?vue&type=template&id=c1c1594a&scoped=true&"
import script from "./yqdj.vue?vue&type=script&lang=js&"
export * from "./yqdj.vue?vue&type=script&lang=js&"
import style0 from "./yqdj.vue?vue&type=style&index=0&id=c1c1594a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c1594a",
  null
  
)

export default component.exports